import { render, staticRenderFns } from "./TicketCustomerDetail.vue?vue&type=template&id=59572e98&scoped=true"
import script from "./TicketCustomerDetail.vue?vue&type=script&lang=js"
export * from "./TicketCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketCustomerDetail.vue?vue&type=style&index=0&id=59572e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59572e98",
  null
  
)

export default component.exports